import { hasRight } from 'nallian-shared-ui/lib/lib/routesHelper';
import { isSystemOrganisation } from '../../../../app/config/systemOrgs';

export const hasIdentificationCodesAccess = (
  rights,
  organisationId,
  principalOrganisationId,
  suffix = 'read'
) => {
  // Check for the basic required right
  if (!hasRight(rights, `identification-codes/${suffix}`)) {
    return false;
  }

  // If organisationId is not the same as the principalOrganisationId, check additional right
  if (organisationId !== principalOrganisationId) {
    if (!hasRight(rights, `identification-codes/other-organisations/${suffix}`)) {
      return false;
    }
  }

  // If organisationId is a system organisation, check additional right
  if (isSystemOrganisation(organisationId)) {
    if (!hasRight(rights, `identification-codes/system-organisations/${suffix}`)) {
      return false;
    }
  }

  // If all checks pass, return true
  return true;
};
